import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, isDevMode } from '@angular/core';
import { Observable } from 'rxjs';

/**
 * HTTP Interceptor performing request adjustments for easier REST API usage.
 *
 * This interceptor will turn on sending cookies along with the request, for each request of type different than
 * 'OPTIONS', using 'withCredentials' setting.
 */
@Injectable({
  providedIn: 'root'
})
export class RestApiInterceptor implements HttpInterceptor {

  intercept(request: HttpRequest<any>, nextHandler: HttpHandler): Observable<HttpEvent<any>> {
    const preFlightRequest = this.isPreFlightRequest(request);

    const apiRequest = request.clone({
      url: request.url,
      withCredentials: preFlightRequest ? request.withCredentials : true
    });
    return nextHandler.handle(apiRequest);
  }

  isPreFlightRequest(request: HttpRequest<any>): boolean {
    const result = ('OPTIONS' === request.method);
    if (result && isDevMode()) {
      console.log('PreFlight Request - Origin: ' + request.headers.get('ORIGIN') + ', ACRM: ' + request.headers.get('Access-Control-Request-Method'));
    }
    return result;
  }

}
